'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { HelpCenterFaqEntryUrl } from '@marketplace-web/help-center/help-center-faq-entry-url-feature'
import {
  AccessChannel,
  FaqEntryType,
} from '@marketplace-web/help-center/help-center-faq-entry-url-data'

import { NEW_HELP_TICKET_URL } from '../../../constants/routes'

type Props = {
  isOpen: boolean
  transactionId: number
  onClose: () => void
}

const InsufficientBalanceModal = ({ isOpen, transactionId, onClose }: Props) => {
  const translate = useTranslate('conversation.insufficient_balance_modal')

  return (
    <HelpCenterFaqEntryUrl
      type={FaqEntryType.InsufficientBalance}
      accessChannel={AccessChannel.ConversationTx}
      render={(url, faqEntryId) => (
        <Dialog
          title={translate('title')}
          body={translate('body')}
          actions={[
            {
              text: translate('actions.contact'),
              style: Dialog.ActionStyling.Filled,
              url: urlWithParams(NEW_HELP_TICKET_URL, {
                access_channel: AccessChannel.ConversationTx,
                faq_entry_id: faqEntryId,
                transactionId,
                allow_direct: '1',
              }),
            },
            {
              text: translate('actions.close'),
              style: Dialog.ActionStyling.Flat,
              callback: onClose,
            },
          ]}
          show={isOpen}
        />
      )}
    />
  )
}

export default InsufficientBalanceModal
